const selectors = {
    el: '.js-commentary-video:not(.has-initialized-commentary-video)',
    video: '.js-video',
    player: '.js-video-player'
}

const classes = {
    visible: 'is-visible'
}

const init = () => {
    const els = document.querySelectorAll(selectors.el);

    let observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: .4
    };
    
    let observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add(classes.visible);
            } else {
                entry.target.classList.remove(classes.visible);
            }
    
        });
    }, observerOptions);

    els.forEach(el => {
        el.classList.add('has-initialized-commentary-video');

        const video = el.querySelector(selectors.video);
        const player = video.querySelector(selectors.player);
        
        video.addEventListener('click', () => {
            if (!video.el) return;

            if (player.paused) {
                video.el.playVideo();
            } else {
                video.el.pauseVideo();
            }
        });

        observer.observe(el);
    });

    window.addEventListener('click', e => {
        els.forEach(el => {
            const video = el.querySelector(selectors.video);
            const isOutsideVideo = e.target !== video && !video.contains(e.target);

            if (isOutsideVideo && video.el.isPlaying) video.el.pauseVideo();
        });
    });
};

const module = () => {
    init();
    document.addEventListener('domUpdated', init);
};

export default module;